import { render } from "./GalleryEmptyState.vue?vue&type=template&id=4af12088&scoped=true"
import script from "./GalleryEmptyState.vue?vue&type=script&lang=js"
export * from "./GalleryEmptyState.vue?vue&type=script&lang=js"

import "./GalleryEmptyState.vue?vue&type=style&index=0&id=4af12088&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af12088"]])

export default __exports__